export type RuntimeLocation = Pick<Location, 'origin' | 'protocol' | 'host' | 'hostname'>

function domain(hostname: string): string {
  if (!hostname.includes('.') || hostname.includes(':') || /^[\d.]+$/.test(hostname)) {
    return hostname
  }

  return hostname.slice(hostname.indexOf('.') + 1)
}

export function resolveEnvPlaceholders(value: string, runtimeLocation?: RuntimeLocation): string
export function resolveEnvPlaceholders(value: undefined, runtimeLocation?: RuntimeLocation): undefined
export function resolveEnvPlaceholders(
  value: string | undefined,
  runtimeLocation?: RuntimeLocation,
): string | undefined
export function resolveEnvPlaceholders(
  value: string | undefined,
  runtimeLocation: RuntimeLocation = window.location,
): string | undefined {
  if (value === undefined || !value.includes('{{')) return value

  const replacements: Record<string, string> = {
    ORIGIN: runtimeLocation.origin,
    PROTOCOL: runtimeLocation.protocol.replace(/:$/, ''),
    HOST: runtimeLocation.host,
    HOSTNAME: runtimeLocation.hostname,
    DOMAIN: domain(runtimeLocation.hostname),
  }

  return value.replace(/\{\{([^{}]+)\}\}/g, (placeholder, key: string) => {
    const replacement = replacements[key]
    if (replacement === undefined) {
      throw new Error(`Unsupported environment placeholder: ${placeholder}`)
    }
    return replacement
  })
}
